import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { TransactionService } from "appworks/services/transaction/transaction-service";
import { State } from "appworks/state-machine/states/state";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { FowlFlingBonusBackgroundComponent } from "components/bonus/fling/fowl-fling-bonus-background-component";
import { FowlFlingBonusComponent } from "components/bonus/fling/fowl-fling-bonus-component";
import { gameLayers } from "game-layers";
import { FowlJackpotBonusResult } from "model/results/fowl-jackpot-bonus-result";
import { SlingoGameProgressResult } from "slingo/model/results/slingo-game-progress-result";
import { BigWinComponent } from "slotworks/components/bigwin/big-win-component";

export class FowlExitFlingBonusState extends State {
    public onEnter(cascadeSkip?: boolean): void {
        const gameplay = gameState.getCurrentGame();
        const result = gameplay.getLatestResultOfType(FowlJackpotBonusResult);
        const totalStake = gameplay.getLatestResultOfType(SlingoGameProgressResult).totalStake;

        result.played = true;

        new Sequence([
            () => Contract.wrap(() => Services.get(SoundService).customEvent("faf_music_stop")),
            () => Components.get(BigWinComponent).showWin(result.cashWon, totalStake),
            () =>
                Contract.wrap(() => {
                    Services.get(TransactionService).setTotalWin(gameplay.getTotalWin());
                }),
            () => gameLayers.ScreenFade.setScene("black"),
            () => Components.get(FowlFlingBonusBackgroundComponent).hide(),
            () => Contract.wrap(() => Components.get(FowlFlingBonusComponent).cleanup()),
            () => gameLayers.FlingBonus.defaultScene(),
        ]).then(() => this.complete());
    }
}
